import { createAction, props } from '@ngrx/store';

export enum PurchaseOrderActionTypes {
  MANDATORY = '[MULTIPLE ORDERS] [PURCHASE ORDER] Purchase order value is required',
  SAVE_MASKS = '[MULTIPLE ORDERS] [PURCHASE ORDER] Save valid format masks',
}

export const isMandatory = createAction(
  PurchaseOrderActionTypes.MANDATORY,
  props<{
    /** Determines whether PO validation is required */
    validationRequired: boolean;
  }>(),
);

export const setValidMasks = createAction(PurchaseOrderActionTypes.SAVE_MASKS, props<{ payload: string[] }>());

export const PurchaseOrderActions = {
  isMandatory,
  setValidMasks,
};
